class LocalStorageProvider {

    private static app = process.env.REACT_APP_NAME!.toLowerCase();
    static getUserInfo(): any | null {
        const url = localStorage.getItem(`${LocalStorageProvider.app}.app.user.info`);
        return url;
    }

    static removeUser(): void {
        localStorage.removeItem(`${LocalStorageProvider.app}.app.user.info`);
        localStorage.removeItem(`${LocalStorageProvider.app}.app.user.token`);
        localStorage.removeItem(`${LocalStorageProvider.app}.rad.user.token`);
    }
    static removeUserInfo(key: string, value: any): void {
        localStorage.removeItem(`${LocalStorageProvider.app}.app.user.info`);
    }

    static getUserToken(): string {
        const token = localStorage.getItem(`${LocalStorageProvider.app}.app.user.token`);
        if (token == null)
            return ``;
        return token;
    }
    static getRadUserToken(): string {
        const token = localStorage.getItem(`${LocalStorageProvider.app}.rad.user.token`);
        if (token == null)
            return ``;
        return token;
    }

    static setUserToken(token: string | null): void {
        if (token == null) {
            localStorage.removeItem(`${LocalStorageProvider.app}.app.user.token`);
            return;
        }
        localStorage.setItem(`${LocalStorageProvider.app}.app.user.token`, token!);
    }

    static setRadUserToken(token: string | null): void {
        if (token == null) {
            localStorage.removeItem(`${LocalStorageProvider.app}.rad.user.token`);
            return;
        }
        localStorage.setItem(`${LocalStorageProvider.app}.rad.user.token`, token!);
    }

    static getUser(): any {
        const info = localStorage.getItem(`${LocalStorageProvider.app}.app.user.info`);
        if (info == null)
            return ``;
        return info;
    }

    static setUser(user: any): void {
        localStorage.setItem(`${LocalStorageProvider.app}.app.user.info`, user);
    }

    static removeUserToken(key: string, value: any): void {
        localStorage.removeItem(`${LocalStorageProvider.app}.app.user.token`);
    }

    static removeRadUserToken(key: string, value: any): void {
        localStorage.removeItem(`${LocalStorageProvider.app}.rad.user.token`);
    }

    static getL10n(): 'fa' | 'en' {
        const l10n = localStorage.getItem(`${LocalStorageProvider.app}.app.l10n`);
        if (l10n === 'fa' || l10n === 'en') {
            return l10n;
        } else {
            return 'fa';
        }
    }

    static setL10n(l10n: 'fa' | 'en' | 'ar'): void {
        localStorage.setItem(`${LocalStorageProvider.app}.app.l10n`, l10n);
    }

    static setItem(key: string, value: any): void {
        localStorage.setItem(`${LocalStorageProvider.app}.app.custom.${key}`, value);
    }

    static getItem(key: string): any | null {
        return localStorage.getItem(`${LocalStorageProvider.app}.app.custom.${key}`);
    }

    static removeItem(key: string, value: any): void {
        localStorage.removeItem(`${LocalStorageProvider.app}.app.custom.${key}`);
    }
}


export default LocalStorageProvider